import React from 'react';
import CheckIcon from '../../common/icons/check';
import { ListItemIcon, ListItemText } from '@mui/material';
import { MenuItem } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import AmbTooltip from '../../common/AmbTooltip';
import AmbCircularProgress from '../../common/AmbCircularProgress';
import AssistTripIcon from '../../common/icons/AssistTripIcon';
import { styled } from '@mui/system';

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 36,
});

const AssistTrip = props => {
  const click = () => {
    props.addAssist();
  };

  const handleClose = () => {
    props.closeErrorModal();
  };

  const shouldShowAddAssist = () => {
    const { request, isDispatcher, isCar } = props;

    return (
      !window.ambulnzConfig.isAnExternalApp && isDispatcher && request && request.id && !request.roundTrip && !isCar
    );
  };

  const assist = (
    <>
      <StyledListItemIcon>
        <AssistTripIcon />
      </StyledListItemIcon>
      <ListItemText primary="Add Assist Trip" />
    </>
  );

  const loading = (
    <>
      <StyledListItemIcon>
        <AmbCircularProgress
          propsStyles={{
            width: '15px',
            height: '15px',
            position: 'relative',
            top: '3px',
          }}
        />
      </StyledListItemIcon>
      <ListItemText primary="Adding Assist Trip" />
    </>
  );

  const finished = (
    <>
      <StyledListItemIcon>
        <CheckIcon style={{ marginRight: 0, width: 24, height: 24 }} />
      </StyledListItemIcon>
      <ListItemText primary="Added Assist Trip" />
    </>
  );

  let content = assist;

  if (props.loading) {
    content = loading;
  }

  if (props.completed) {
    content = finished;
  }

  const tooltipTitle = props.isAssisted ? 'You cannot create an assist trip on this trip.' : '';

  const requestAssistButton = (
    <AmbTooltip title={tooltipTitle}>
      <span>
        <MenuItem onClick={() => click()} disabled={props.isAssisted || null} sx={{ minHeight: '48px !important' }}>
          {content}
        </MenuItem>
      </span>
    </AmbTooltip>
  );

  return (
    <>
      {shouldShowAddAssist() ? requestAssistButton : ''}

      <Dialog
        open={!!props.errorMessage}
        onClose={() => handleClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add Assist Trip Failed</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{props.errorMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose()}
            color="primary"
            autoFocus
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(30, 192, 217, 0.1)',
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssistTrip;
